module.exports = __webpack_public_path__ + "static/media/apple-launch-img.fcac3c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/images/touch/apple-launch-img.png
// module id = 273
// module chunks = 61